import { PServed, HistoryMessageItem, MessageOutgoingEvent } from '@wui/im'
import { ref } from 'vue'

import { chatModel } from '@/entities/messages'

type MessageTuple = [HistoryMessageItem<MessageOutgoingEvent>, PServed]
const unsentMessagesMap = ref(new Map<number, MessageTuple>())
const LOCAL_STORAGE_KEY = 'web-client-unsent-messages'

type DataInLocalStorage = { [key in number]: MessageTuple }
const getDataFromLocalStorage = (): DataInLocalStorage | null => {
  const string = localStorage.getItem(LOCAL_STORAGE_KEY)
  if (string) {
    try {
      return JSON.parse(string)
    } catch (e) {
      console.error(e)
      return null
    }
  } else {
    return null
  }
}

const setMessageInLocalStorage = (event: HistoryMessageItem<MessageOutgoingEvent>, pServed: PServed): void => {
  const data: DataInLocalStorage = getDataFromLocalStorage() ?? {}

  data[event.eventId] = [event, pServed]

  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(data))
}

const deleteMessageInLocalStorage = (eventId: number): void => {
  const data: DataInLocalStorage = getDataFromLocalStorage() ?? {}

  if (!data) return

  delete data[eventId]
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(data))
}

export const useUnsentMessageHandler = () => {
  const setUnsentMessage = (event: HistoryMessageItem<MessageOutgoingEvent>, pServed: PServed) => {
    const { eventId } = event
    unsentMessagesMap.value.set(eventId, [event, pServed])
    setMessageInLocalStorage(event, pServed)
    return eventId
  }

  const deleteUnsentMessage = (id: number) => {
    unsentMessagesMap.value.delete(id)
    deleteMessageInLocalStorage(id)
  }

  const init = () => {
    const data = getDataFromLocalStorage()
    if (!data) return

    Object.keys(data).forEach((key: string) => {
      const typedKey = +key
      const value = data[typedKey]
      if (!value) return

      chatModel.useChatMessageStore().addMessage(value[1], value[0])

      unsentMessagesMap.value.set(typedKey, value)
    })
  }

  const clear = () => {
    localStorage.removeItem(LOCAL_STORAGE_KEY)
  }

  return {
    setUnsentMessage,
    deleteUnsentMessage,
    init,
    clear,
  }
}
